<template>
  <footer class="custom-footer py-5 position-relative">
    <BContainer>
      <BRow>
        <BCol lg="6" class="mt-4">
          <div>
            <div>
              <img
                src="@/assets/images/sander/sander_weiss.png"
                alt="logo light"
                height="40"
                @click="handleLogoClick"
              />
            </div>
            <div class="mt-4 fs-15">
              <p class="fw-bold">{{ $t("t-landing-footer-heading") }}</p>
              <p>
                {{ $t("t-landing-footer-lead") }}
              </p>
            </div>
          </div>
        </BCol>

        <BCol lg="2" class="ms-auto" style="font-weight: 500">
          <BRow>
            <BCol sm="12" class="mt-4 ms-auto">
              <div class="text-muted mt-3">
                <ul class="list-unstyled footer-list">
                  <li>
                    <router-link to="/faq" @click="topFunction">{{
                      $t("t-landing-footer-faq")
                    }}</router-link>
                  </li>
                  <li>
                    <router-link to="/about" @click="topFunction">{{
                      $t("t-landing-footer-heading")
                    }}</router-link>
                  </li>
                  <li>
                    <router-link to="/contact" @click="topFunction">{{
                      $t("t-landing-footer-contact")
                    }}</router-link>
                  </li>
                  <li>
                    <a
                      href="https://subscribe.newsletter2go.com/?n2g=bhiskr47-nphiv59f-rxa&_ga=2.252266441.1525145637.1588670699-675360909.1583393004"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Newsletter
                    </a>
                  </li>
                  <li>
                    <router-link to="/cookies" @click="topFunction">{{
                      $t("t-cookies-settings-title")
                    }}</router-link>
                  </li>
                  <li>
                    <router-link to="/privacy" @click="topFunction">{{
                      $t("t-landing-footer-privacy")
                    }}</router-link>
                  </li>
                  <li>
                    <router-link to="/imprint" @click="topFunction">{{
                      $t("t-landing-footer-imprint")
                    }}</router-link>
                  </li>
                </ul>
              </div>
            </BCol>
          </BRow>
        </BCol>
      </BRow>

      <!-- Hier fügst du eine zweite Spalte in derselben row ein, 
           damit links dein Copyright,
           rechts die Social-Media-Icons. -->
      <BRow class="text-center text-sm-start align-items-center mt-5">
        <BCol sm="6">
          <div>
            <p class="copy-rights mb-0 currentyear">
              {{ new Date().getFullYear() }} © Sander Fördertechnik GmbH
            </p>
          </div>
        </BCol>

        <!-- NEUE SPALTE FÜR SOCIAL LINKS -->
        <BCol sm="6" class="text-center text-sm-end mt-3 mt-sm-0 social-col">
          <ul class="list-inline mb-0 social-list">
            <li class="list-inline-item me-2">
              <a
                href="https://www.youtube.com/@sander-ft"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="@/assets/images/social_media/youtube.png"
                  alt="YouTube"
                  height="30"
                />
              </a>
            </li>
            <li class="list-inline-item me-2">
              <a
                href="https://www.instagram.com/sander_foerdertechnik/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="@/assets/images/social_media/instagram.png"
                  alt="Instagram"
                  height="30"
                />
              </a>
            </li>
            <li class="list-inline-item me-2">
              <a
                href="https://www.linkedin.com/company/sander-f-rdertechnik-gmbh/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="@/assets/images/social_media/linkedin.png"
                  alt="LinkedIn"
                  height="30"
                />
              </a>
            </li>
            <li class="list-inline-item me-2">
              <a
                href="https://www.facebook.com/sander.foerdertechnik.gmbh/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="@/assets/images/social_media/facebook.png"
                  alt="Facebook"
                  height="30"
                />
              </a>
            </li>
            <li class="list-inline-item">
              <a
                href="https://www.xing.com/pages/sanderfordertechnikgmbh"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="@/assets/images/social_media/xing.png"
                  alt="Xing"
                  height="30"
                />
              </a>
            </li>
          </ul>
        </BCol>
      </BRow>
    </BContainer>

    <!-- Button "Back to top" -->
    <BButton
      variant="primary"
      @click="topFunction"
      class="btn-icon"
      id="back-to-top"
    >
      <i class="ri-arrow-up-line"></i>
    </BButton>
  </footer>
</template>

<script>
export default {
  /*
  beforeRouteEnter(to, from, next) {
    if (from.name !== "products" && !from.name.startsWith("products/")) {
      next((vm) => {
        vm.$nextTick(() => {
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 300); // 300ms Delay, ggf. anpassen
        });
      });
    } else {
      next();
    }
  },
  */
  data() {
    return {
      clickCount: 0,
      clickTimer: null,
    };
  },

  methods: {
    topFunction() {
      //document.body.scrollTop = 0;
      //document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);
    },
    handleLogoClick() {
      this.clickCount++;
      // Setze einen Timer, um den Klick-Zähler nach 1 Sekunde zurückzusetzen (optional)
      clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(() => {
        this.clickCount = 0;
      }, 1000);

      // Wenn vier oder mehr Klicks registriert wurden, navigiere zur Route /main
      if (this.clickCount >= 4) {
        this.$router.push("/log");
        this.clickCount = 0; // Zurücksetzen des Zählers
      }
    },
  },
};
</script>
